import axios from '@axios';
import qs from 'qs';

export function getLocations(query = {}) {
    query = qs.stringify(query);
    return axios.get(`/locations?${query}`);
}
